import { useState, useRef, useEffect, useCallback } from 'react';
import { userGroupsService } from '@modules/userGroups/services/userGroupsService';

export const useUserGroupsMenu = ({ onClose, onSave, groupData }) => {
    const [selectedMenus, setSelectedMenus] = useState([]);
    const [menus, setMenus] = useState([]);
    const modalRef = useRef();

    useEffect(() => {
        const initializeMenus = async () => {
            try {
                const data = await userGroupsService.getMenus();
                setMenus(data);

                if (groupData?.specRights) {
                    setSelectedMenus(groupData.specRights.map(id => ({ id })));
                }
            } catch (error) {
                console.error('Error initializing menus:', error);
            }
        };

        initializeMenus();
    }, [groupData]);

    const handleCheckboxChange = useCallback((event) => {
        const value = parseInt(event.target.value);
        const isChecked = event.target.checked;

        setSelectedMenus(prev =>
            isChecked
                ? [...prev, { id: value }]
                : prev.filter(menu => menu.id !== value)
        );
    }, []);

    const handleSelectAll = useCallback((event) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            const roleMenus = groupData.specRights
                .filter(right => right.code)
                .map(right => ({ 
                    id: right.id, 
                    code: right.code 
                }));
            const allMenus = menus.map(menu => ({ 
                id: menu.id, 
                code: menu.code 
            }));
            setSelectedMenus([...allMenus, ...roleMenus]);
        } else {
            setSelectedMenus(
                groupData.specRights
                    .filter(right => right.code)
                    .map(right => ({ 
                        id: right.id, 
                        code: right.code 
                    }))
            );
        }
    }, [groupData.specRights, menus]);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        try {
            const data = {
                specRights: selectedMenus
            };

            await onSave(data);
            onClose();
        } catch (error) {
            console.error('Error saving menus:', error);
        }
    }, [selectedMenus, onSave, onClose]);

    const handleClickOutside = useCallback((event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    }, [onClose]);

    const isAllSelected = useCallback(() => 
        menus.length > 0 && 
        selectedMenus.filter(menu => !menu.code?.startsWith('ROLE')).length === menus.length,
    [menus.length, selectedMenus]);

    return {
        modalRef,
        selectedMenus,
        menus,
        isAllSelected: isAllSelected(),
        handleCheckboxChange,
        handleSelectAll,
        handleSubmit,
        handleClickOutside
    };
}; 